import { BewerberStatus, BewerberStatusConfig } from '../../types/bewerber';

interface BewerberStatusBadgeProps {
  status: BewerberStatus;
  className?: string;
}

export function BewerberStatusBadge({ status, className = '' }: BewerberStatusBadgeProps) {
  const config = BewerberStatusConfig[status];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.color} ${className}`}
    >
      {config.label}
    </span>
  );
}
